import { Add } from "iconsax-react";
import React, { useState } from "react";

type Props = {
  confirmMessage: string;
  closeToast: () => void;
  confirmFunc: () => void;
  confirmText?: string;
  cancelText?: string;
  backdropClosable?: boolean;
};

const ConfirmToast: React.FC<Props> = ({
  confirmMessage,
  closeToast,
  confirmFunc,
  confirmText = "بله",
  cancelText = "انصراف",
  backdropClosable = true,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleConfirm = () => {
    confirmFunc();
    setIsVisible(false);
  };

  const handleCancel = () => {
    closeToast();
    setIsVisible(false);
  };

  const handleBackdropClick = () => {
    if (backdropClosable) {
      closeToast();
      setIsVisible(false);
    }
  };

  const handleCloseClick = () => {
    closeToast();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed top-0 left-0 w-full h-full bg-black/50  flex justify-center items-center z-9999"
      onClick={handleBackdropClick}
    >
      <div
        className="bg-white py-10 pb-6 px-5 rounded-2xl max-w-125 w-full relative  "
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={handleCloseClick}
          className="absolute top-3 left-3 bg-transparent border-0 text-lg cursor-pointer text-ws-gray-600"
        >
          <Add color="#000" size={30} className="rotate-45" />
        </button>

        <p className="text-ws-gray-600 text-center">{confirmMessage}</p>
        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={handleCancel}
            className="bg-ws-grayBlue-100 border-2 cursor-pointer border-ws-gray-600 px-13 py-2 rounded-xl w-25 text-center flex items-center justify-center"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className="bg-transparent cursor-pointer border-2 px-13 py-2 rounded-xl text-center flex items-center justify-center w-25 border-ws-gray-600 hover:text-white hover:bg-ws-gray-600 transition duration-300 hover:transition hover:duration-300"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmToast;
